import { createSlice } from '@reduxjs/toolkit';
import { ApiOrganisation, ApiRole, ApiUser } from '../api';

export interface UsersState {
  users: ApiUser[];
  loadingUsers: boolean;
  rolesForMultiSelect: ApiRole[];
  rolesForFilters: ApiRole[];
  organisationsForSelect: ApiOrganisation[];
}

const initialState: UsersState = {
  users: [],
  loadingUsers: false,
  rolesForMultiSelect: [],
  rolesForFilters: [],
  organisationsForSelect: [],
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setLoadingUsers: (state, action) => {
      state.loadingUsers = action.payload;
    },
    fetchRolesMultiSelectSuccess: (state, action) => {
      state.rolesForMultiSelect = action.payload.content;
    },
    fetchRolesForFiltersSuccess: (state, action) => {
      state.rolesForFilters = action.payload.content;
    },
    fetchOrganisationMultiSelectSuccess: (state, action) => {
      state.organisationsForSelect = action.payload.content;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = usersSlice;
// Extract and export each action creator by name
export const {
  setLoadingUsers,
  fetchRolesMultiSelectSuccess,
  fetchRolesForFiltersSuccess,
  fetchOrganisationMultiSelectSuccess,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
